import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cronParser from 'cron-parser'
import moment from 'moment'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link } from 'react-router-dom'

import getTimestamp from 'utils/getTimestamp'
import preventDefault from 'utils/preventDefault'
import SiteSchedulesRunList from './site-schedule-run-list'
import { getCurrentSiteSchedule } from 'modules/schedules/selectors'
import { loadSchedules, setSiteSchedule } from 'modules/schedules/actions'
import { getSubscriptionPlan } from 'modules/subscriptions'
import { ACCOUNT_BILLING_PATH } from 'config'


class SiteSchedules extends Component {
  static propTypes = {
    loadSchedules: PropTypes.func.isRequired,
    schedule: PropTypes.shape({
      account: PropTypes.string.isRequired,
      cron: PropTypes.shape({
        expression: PropTypes.string.isRequired,
        timezone: PropTypes.string.isRequired
      }).isRequired,
      nextRun: PropTypes.number,
      site: PropTypes.string.isRequired,
    }),
    setSiteSchedule: PropTypes.func.isRequired,
    subscriptionPlan: PropTypes.string,
  }

  constructor(props, context) {
    super(props, context)

    this.state = {
      expression: this.scheduleExpression(),
      timezone: moment.tz.guess() || 'EST'
    }
  }

  componentDidMount() {
    this.props.loadSchedules()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.schedule !== this.props.schedule) {
      this.onExpressionChange({ target: { value: this.scheduleExpression(nextProps) } })
    }
  }

  scheduleExpression = props => {
    return (((props || this.props).schedule || {}).cron || {}).expression || ''
  }

  submitSchedule = () => {
    const { expression } = this.state
    const { schedule, setSiteSchedule } = this.props
    const nextRun = getTimestamp(this.parseExpression(expression).next().value)
    const cron = { expression, timezone: this.state.timezone }

    setSiteSchedule({ cron, nextRun, key: (schedule || {}).key })
  }

  removeSchedule = () => {
    this.props.setSiteSchedule({ remove: true, key: (this.props.schedule || {}).key })
  }

  parseExpression(expression, currentDate) {
    const parserOptions = { iterator: true, tz: this.state.timezone, currentDate }

    return expression ? cronParser.parseExpression(expression, parserOptions) : null
  }

  onExpressionChange = ({ target: { value: expression } }) => {
    try {
      this.parseExpression(expression)
      this.setState({ expression, error: false })
    }
    catch (e) {
      this.setState({ expression, error: true })
    }
  }

  isTouched = () => {
    const { schedule } = this.props
    const { expression } = this.state

    return (typeof schedule === 'undefined' && expression) || (!!schedule && schedule.cron.expression !== expression)
  }

  renderSubmitButton = hasSchedule => {
    let isDisabled
    let buttonLabel

    if (hasSchedule) {
      buttonLabel = 'Edit'
      isDisabled = !this.isTouched()
    }
    else {
      buttonLabel = 'Add'
      isDisabled = this.state.error || !this.state.expression.length
    }

    return (
      <button type="submit" className="btn btn-primary mr-2" disabled={isDisabled}>
        {buttonLabel}
      </button>
    )
  }

  render() {
    const { schedule, subscriptionPlan } = this.props
    const { expression, error } = this.state
    const hasSchedule = !!schedule
    const nextRun = schedule && schedule.nextRun

    if (!(subscriptionPlan && subscriptionPlan !== 'basic')) {
      return (
        <div className="card card-block mb-4">
          <h4 className="text-center mb-4">Schedules</h4>
          <div className="text-center">
            <h5>Schedules are not available on a basic plan. Please upgrade to use them.</h5>
            <Link to={ACCOUNT_BILLING_PATH} className="btn btn-primary m-3">
              Upgrade
            </Link>
          </div>
        </div>
      )
    }
    return (
      <form className="card card-block site-form mb-4" autoComplete="off" onSubmit={preventDefault(this.submitSchedule)}>
        <h4 className="text-center mb-4">Schedules</h4>
        <div className="form-group row">
          <label htmlFor="cron-expression" className="col-sm-3 col-form-label">Cron Expression</label>
          <div className="col-sm-9">
            <input
              type="text" name="expression" className="form-control mr-3 mb-1" placeholder="0 0,12 * * *"
              value={expression} onChange={this.onExpressionChange}
            />
            <span>
              {this.renderSubmitButton(hasSchedule)}
            </span>
            { hasSchedule && (
              <span>
                <button className="btn btn-default" onClick={preventDefault(this.removeSchedule)}>
                  Remove
                </button>
              </span>
            )}
          </div>
        </div>
        { (this.isTouched() && expression) && (
          <div className={ classNames('form-helper', { 'text-danger': error, 'text-success': !error }) }>
            { `cronjob is ${error ? 'invalid' : 'valid'}` }
          </div>
        )}
        { !error && (
          <SiteSchedulesRunList expression={this.parseExpression(expression, nextRun)} />
        ) }
      </form>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  schedule: getCurrentSiteSchedule,
  subscriptionPlan: getSubscriptionPlan,
})
const mapDispatchToProps = { loadSchedules, setSiteSchedule }

export default connect(mapStateToProps, mapDispatchToProps)(SiteSchedules)



// WEBPACK FOOTER //
// ./src/components/sites/schedules/site-schedule.js